/* surfcast — built by KAAI. Self-contained: no framework, no KAAI runtime.
   Rendered into <div id="surfcast"> wherever the snippet is included. */
/* surfcast · kaai · Tel Aviv
   ---------------------------------------------------------------------------------
   Emitted by the studio part surf_widget_js. Do not edit this file inside the theme —
   the next build overwrites it, and which break it points at is surf_read's to decide.

   The strip reads the sea in the shopper's own browser, once on load and then hourly,
   from a free keyless marine feed. It is a FORECAST, and the word תחזית on the strip
   says so: a black band across a shop's header reads as fact unless it says otherwise.
   --------------------------------------------------------------------------------- */
(function () {
  "use strict";

  /* THE POINT this strip was built for, written down so a later reader can name the
     break. surf_read is the single owner of which point it is — change it there and
     rebuild. A coordinate edited here would be a second answer to the same question. */
  var SPOT = "Tel Aviv";
  var LAT = 32.08;
  var LON = 34.77;

  var MOUNT_ID = "surfcast";
  var FEED = "https://marine-api.open-meteo.com/v1/marine";
  var HOURLY = "wave_height,wave_period,sea_surface_temperature";
  var HOUR_MS = 3600000;
  var WAIT_MS = 15000;   /* the same 15s surf_read gives this same feed */

  /* SEVEN BANDS in ONE table — the threshold, the surfer's name for it, and the mark,
     side by side, so a later reader retunes the surf in one place. Every mark is the
     same 24x24 box: the wave inside grows and steepens, the box never does, so the
     strip keeps its rhythm however big the swell gets. */
  var BANDS = [
    { under: 0.3, name: "שטוח", d: '<path d="M1.5 17c3.5 0 4-.6 6-.6s3 .6 5 .6 3-.6 5-.6 3 .6 5 .6"/>' },
    { under: 0.5, name: "קרסול", d: '<path d="M1.5 17.5c3.2 0 4-1 6-2.2 1.8-1.1 3.4-1.6 5.2-1.6 2.4 0 4 .8 4.8 2-1-.7-2-1-3.2-1-1.8 0-3 .6-4.2 1.6"/><path d="M1.5 17.5c4 1.2 7.4 1.2 11 0" opacity=".45"/>' },
    { under: 0.8, name: "ברך", d: '<path d="M1.5 18c3.4 0 4.2-1.4 6.2-3.2 2-1.8 3.8-2.8 6-2.8 2.6 0 4.4 1.2 5.2 2.9-1.1-1-2.3-1.5-3.7-1.5-2 0-3.4.9-4.6 2.2"/><path d="M1.5 18c4 1.4 7.6 1.4 11.2 0" opacity=".45"/>' },
    { under: 1.1, name: "מותן", d: '<path d="M1.5 18.4c3.5 0 4.4-1.8 6.4-4 2.4-2.6 4.4-4.2 7-4.2 2.8 0 4.8 1.5 5.6 3.6-1.1-1.2-2.5-1.9-4-1.9-2.2 0-3.7 1.1-5 2.7"/><path d="M1.5 18.4c4 1.5 7.6 1.5 11.4 0" opacity=".45"/>' },
    { under: 1.4, name: "חזה", d: '<path d="M1.5 18.8c3.5 0 4.5-2.2 6.5-4.8 2.6-3.4 4.8-5.6 7.6-5.6 3 0 5 1.8 5.8 4.2-1.1-1.4-2.6-2.2-4.2-2.2-2.3 0-3.9 1.3-5.2 3.1"/><path d="M1.5 18.8c4 1.6 7.6 1.6 11.6 0" opacity=".45"/>' },
    { under: 1.8, name: "ראש", d: '<path d="M1.5 19.2c3.5 0 4.6-2.6 6.6-5.6C10.9 9.2 13.4 6.4 16.6 6.4c3.2 0 5.2 2 6 4.6-1.2-1.6-2.8-2.5-4.5-2.5-2.5 0-4.2 1.5-5.5 3.5"/><path d="M1.5 19.2c4.2 1.7 8 1.7 12 0" opacity=".45"/>' },
    { under: Infinity, name: "מעל הראש", d: '<path d="M1.5 19.6c3.6 0 4.8-3 6.8-6.4C11.2 7.6 14 4.2 17.4 4.2c3.4 0 5.4 2.2 6.1 5-1.2-1.8-2.9-2.8-4.7-2.8-2.7 0-4.5 1.7-5.8 3.9"/><path d="M1.5 19.6c4.3 1.8 8.2 1.8 12.3 0" opacity=".45"/>' }
  ];

  /* The words הים שטוח and the שטוח mark read the same number out of the same table.
     Two copies of 0.3 is how a picture ends up disagreeing with its own caption. */
  var FLAT_M = BANDS[0].under;

  /* One attribute set for every mark: 24x24 box, the strip's own white by currentColor,
     stroke 1.7, about 1.05em. The size is written HERE, on the mark, and not in the
     sheet — a stylesheet that fails to load would otherwise leave a bare <svg> at its
     300x150 default across the shop's header. */
  var MARK = 'class="sc-i" width="1.05em" height="1.05em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"';

  var SUN = '<svg ' + MARK + ' aria-hidden="true"><circle cx="12" cy="12" r="4"/><path d="M12 3.2v1.9M12 18.9v1.9M3.2 12h1.9M18.9 12h1.9M6.1 6.1l1.4 1.4M16.5 16.5l1.4 1.4M17.9 6.1l-1.4 1.4M7.5 16.5l-1.4 1.4"/></svg>';

  var THERM = '<svg ' + MARK + ' aria-hidden="true"><path d="M14 14.4V5.2a2 2 0 1 0-4 0v9.2a3.8 3.8 0 1 0 4 0z" stroke-linejoin="round"/><path d="M16.4 7h2.4M16.4 10.4h1.5M16.4 13.8h2.4"/><circle cx="12" cy="17.6" r="1.5" fill="currentColor" stroke="none"/></svg>';

  var last = null;   /* the last reading that actually parsed */
  var lastAt = 0;
  var busy = false;

  function mount() { return document.getElementById(MOUNT_ID); }

  function bandFor(h) {
    for (var i = 0; i < BANDS.length; i++) { if (h < BANDS[i].under) { return BANDS[i]; } }
    return BANDS[BANDS.length - 1];
  }

  /* The band's Hebrew name goes in the mark's title, so a hover names it. The visible
     text stays exactly the three fields. */
  function waveMark(h) {
    var b = bandFor(h);
    return '<svg ' + MARK + ' stroke-linejoin="round" role="img"><title>' + b.name + '</title>' + b.d + '</svg>';
  }

  function field(mark, words) {
    return '<span class="sc-f">' + mark + '<span>' + words + '</span></span>';
  }

  function sep() { return '<span class="sc-sep">·</span>'; }

  function strip(r) {
    var parts = [field(SUN, "תחזית")];
    if (r.flat) {
      /* under 0.3 there is no surf to describe, so the strip says so and keeps its mark
         rather than printing three fields of nearly nothing */
      parts.push(sep(), field(waveMark(r.h), "הים שטוח"));
    } else {
      /* one decimal on the wave because 0.8 and 1.1 are different surf and 0.83 is not;
         whole seconds on the period because nobody reads a tenth of one */
      parts.push(sep(), field(waveMark(r.h), "גלים " + r.h.toFixed(1) + "מ׳"));
      parts.push(sep(), field("", "מחזור " + Math.round(r.p) + "שנ׳"));
      parts.push(sep(), field(THERM, "מים " + r.t.toFixed(1) + "°C"));
    }
    return '<div class="sc-strip" dir="rtl">' + parts.join("") + '</div>';
  }

  function paint(r) {
    var el = mount();
    if (!el) { return; }
    el.innerHTML = strip(r);
    /* the break's name lives in the DOM, not on the strip — the three fields are the
       three fields, but a reader with an inspector open should not have to guess which
       sea this is */
    el.setAttribute("data-spot", SPOT);
    /* the sheet paints nothing until this is set, so a feed that never answered leaves
       no empty black band across the top of the shop */
    el.setAttribute("data-surfcast", "on");
  }

  function num(v) {
    var n = (typeof v === "number") ? v : parseFloat(v);
    return (typeof n === "number" && isFinite(n)) ? n : null;
  }

  function atUTC(t) {
    var s = String(t);
    return /(Z|[+-]\d{2}:\d{2})$/.test(s) ? Date.parse(s) : Date.parse(s + "Z");
  }

  /* The feed is asked with no timezone, so its hours are GMT. Match on the current UTC
     hour rather than on the shopper's clock — the shopper may be nowhere near this
     break, and row zero could be yesterday morning. */
  function hourIndex(times) {
    var stamp = new Date().toISOString().slice(0, 13);
    var i;
    for (i = 0; i < times.length; i++) {
      if (String(times[i]).slice(0, 13) === stamp) { return i; }
    }
    var best = -1, gap = Infinity, now = Date.now();
    for (i = 0; i < times.length; i++) {
      var ms = atUTC(times[i]);
      if (isNaN(ms)) { continue; }
      var d = Math.abs(ms - now);
      if (d < gap) { gap = d; best = i; }
    }
    return best;
  }

  /* null means the shape is wrong, and a wrong shape shows nothing at all rather than
     half a strip or a guessed number. */
  function reading(payload) {
    var H = payload && payload.hourly;
    if (!H || !H.time || !H.time.length) { return null; }
    var i = hourIndex(H.time);
    if (i < 0) { return null; }
    var h = num(H.wave_height && H.wave_height[i]);
    if (h === null) { return null; }
    if (h < FLAT_M) { return { h: h, p: null, t: null, flat: true }; }
    var p = num(H.wave_period && H.wave_period[i]);
    var t = num(H.sea_surface_temperature && H.sea_surface_temperature[i]);
    if (p === null || t === null) { return null; }
    return { h: h, p: p, t: t, flat: false };
  }

  function read() {
    if (busy) { return; }
    busy = true;
    var url = FEED + "?latitude=" + LAT + "&longitude=" + LON + "&hourly=" + HOURLY;
    var ctl = (typeof AbortController === "function") ? new AbortController() : null;
    var bell = ctl ? setTimeout(function () { ctl.abort(); }, WAIT_MS) : null;
    fetch(url, ctl ? { signal: ctl.signal } : undefined)
      .then(function (res) { if (!res.ok) { throw new Error(String(res.status)); } return res.json(); })
      .then(function (payload) {
        var r = reading(payload);
        if (!r) { throw new Error("shape"); }
        var same = last && last.h === r.h && last.p === r.p && last.t === r.t;
        last = r;
        lastAt = Date.now();
        /* an identical reading is the same strip — repainting it only throws away the
           DOM the shopper is already reading */
        if (!same) { paint(r); }
      })
      .catch(function () {
        /* Down, slow, or malformed: say nothing. Nothing is cleared here on purpose —
           the last good strip stays up, because an hour-old reading beats a blank black
           band, and if nothing has ever parsed the mount is still empty and paints. */
      })
      .then(function () { if (bell) { clearTimeout(bell); } busy = false; });
  }

  function start() {
    if (!mount()) { return; }            /* the snippet did not run on this page — leave quietly */
    if (typeof window.fetch !== "function") { return; }
    read();

    /* Hourly, because the feed's own rows are hourly and a faster timer asks a free
       service for a number that has not changed. Only while the tab is being looked at:
       a bare setInterval wakes a backgrounded phone for nothing. */
    setInterval(function () {
      if (document.visibilityState !== "hidden") { read(); }
    }, HOUR_MS);

    /* and when the tab comes back, if the reading on screen has gone stale */
    document.addEventListener("visibilitychange", function () {
      if (document.visibilityState === "visible" && (Date.now() - lastAt) >= HOUR_MS) { read(); }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
